import { useForm, SubmitHandler, Controller, SubmitErrorHandler } from "react-hook-form";
import styles from "./index.module.scss";
import { useState } from "react";
import { useAuthRecovery } from "@/domains/auth/hooks/user-auth-recovery";
import { PhoneInput } from "@/components/UI/PhoneInput/PhoneInput";
import { useStore } from "@/hooks/use-store";
import { showToast } from "@/utils/show-toast";
import { useTranslations } from "next-intl";

interface ShippingField {
  phoneInput: string;
  country: string;
}

interface RecoveryPasswordProps {
  onShowTab: (name: string) => void;
}

export default function RecoveryPassword({ onShowTab }: RecoveryPasswordProps) {
  const {
    handleSubmit,
    formState: { errors },
    control,
  } = useForm<ShippingField>({
    mode: "all",
  });
  const { modal } = useStore();
  const { loading, onMutateAuth, renderErrorMessage, error: authError } = useAuthRecovery();
  const t = useTranslations("ModalRecovery");
  const tValidation = useTranslations("Validation");

  const [country, setCountry] = useState<string>("UA");

  const onSubmit: SubmitHandler<ShippingField> = async (data) => {
    try {
      const cleanedPhone = data.phoneInput.replace("+", ""); // Убираем "+"
      const res = await onMutateAuth({ phone: cleanedPhone, countryCode: country.toUpperCase() });

      if (res?.success) {
        showToast({ message: t("successSend") });

        modal.closeModal();
      }
    } catch (error) {
      if (error instanceof Error) {
        console.error(error.message);
      }
    }
  };

  const onInvalid: SubmitErrorHandler<ShippingField> = (_errors) => {
    console.log("Validation errors: " + JSON.stringify(_errors));
  };

  const handleFormSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    void handleSubmit(onSubmit, onInvalid)();
  };

  const handleCountryChange = (value: string) => {
    if (value) {
      setCountry(value);
    }
  };

  return (
    <div className={styles.form_wrapper}>
      <div className={styles.header}>
        <div className={styles.title}>Восстановление пароля</div>
      </div>

      <form className={styles.form} onSubmit={handleFormSubmit}>
        <div className={styles.form__field}>
          <label className={`${styles.label} ${styles.phone_label}`}>
            <Controller
              name="phoneInput"
              control={control}
              rules={{ required: tValidation("required") }}
              render={({ field: { onChange, value } }) => (
                <PhoneInput
                  autoComplete="off"
                  defaultCountry={country}
                  className={styles.phone_input}
                  value={value}
                  onChange={(_phone, _country) => {
                    onChange(_phone);
                    handleCountryChange(_country);
                  }}
                  label={false}
                  placeholder="Введите номер телефона"
                />
              )}
            />
          </label>
          <div className={styles.message}>{renderErrorMessage("phone", authError || [])}</div>
          {errors.phoneInput && <div className={styles.message}>{errors.phoneInput.message}</div>}
        </div>

        <div className={styles.form__field}>
          <button className={styles.btn_submit} type="submit" disabled={loading}>
            {loading ? "Отправка..." : "Получить пароль"}
          </button>
        </div>
      </form>

      <button className={styles.btn_back} onClick={() => onShowTab("login")}>
        Вход
      </button>
    </div>
  );
}
